import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BaseTableColumn } from '../../models/app-models/BaseTableColumn.model';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-selectable-table',
  templateUrl: './selectable-table.component.html',
  styleUrls: ['./selectable-table.component.scss']
})
export class SelectableTableComponent<T> {
  @Input() data!: T[];
  @Input() totalCount: number = 0
  @Input() columns: BaseTableColumn<T>[] = [];
  @Input() selection: SelectionModel<T> = new SelectionModel<any>(true, []);
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  dataSource: MatTableDataSource<T> = new MatTableDataSource<T>();
  pageSize = 5;
  pageIndex = 0;
  pageSizeOptions = [5, 10, 25];
  displayedColumns: string[] = [];
  pageEvent!: PageEvent
  @Output() pageDetailsHandler: EventEmitter<PageEvent> = new EventEmitter<PageEvent>()
  @Output() searchHandler: EventEmitter<SearchInput> = new EventEmitter<SearchInput>()
  constructor() {
  }
  ngOnInit() {
    this.displayedColumns = this.columns.map(c => c.columnDef);
    this.dataSource = new MatTableDataSource<T>(this.data);
  }
  
  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.pageDetailsHandler.emit(e);
  }



  isString(value: any) {
    const htmlRegex = /<([a-z]+)(?![^>]*\/>)[^>]*>/
    const isHTML = htmlRegex.test(value)
    return (!isHTML)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'].currentValue) {
      this.dataSource.data = changes['data'].currentValue
    }
  }
  // Whether the number of selected elements matches the total number of rows.
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  // Selects all rows if they are not all selected; otherwise clear selection.
  toggleAllRows() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (!this.searchHandler) this.dataSource.filter = filterValue.trim().toLowerCase();
    else this.searchHandler.emit({ searchValue: filterValue, pageSize: this.pageSize, pageIndex: this.pageIndex })
  }
}
export interface SearchInput {
  searchValue: string
  pageSize: number
  pageIndex: number
}